(function () {
  var root = document.querySelector('[data-ilmas-pdp]');
  var api = window.IlmasPdp;
  if (!root || !api) return;

  var SPEC_RE = /dimensi|medida|profund|capacidad|familia|forma|peso|largo|ancho|alto|volumen|plazas|personas|jets|potencia|voltaje|litros|metros|longitud|anchura|altura|casco|acabado/i;
  var YES_RE = /^(s[ií]|yes|incluido|incl\.?|standard|est[aá]ndar|true|ok)$/i;

  function isFeature(row) {
    if (YES_RE.test(row.value)) return true;
    if (SPEC_RE.test(row.label)) return false;
    return /caracter|equip|incluye|dotaci/i.test(row.label) && row.value.length <= 28;
  }

  function featureNames(tmp, pairs) {
    var names = [];
    pairs.forEach(function (p) {
      if (YES_RE.test(p.value)) names.push(p.label);
      else if (/caracter|equip|incluye|dotaci/i.test(p.label) && p.value.length < 40) names.push(p.value);
    });
    tmp.querySelectorAll('li').forEach(function (li) {
      if (li.closest('.attribute-values, .expand-content')) return;
      var t = api.textOf(li);
      if (!t || t.length > 90 || t.indexOf(':') !== -1 || api.JUNK_RE.test(t)) return;
      if (names.indexOf(t) === -1) names.push(t);
    });
    return names.slice(0, 8);
  }

  function fillItems(el, items, tag, className) {
    if (!el) return;
    el.innerHTML = '';
    items.forEach(function (item) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      node.textContent = item;
      el.appendChild(node);
    });
  }

  function fillFacts(el, pairs) {
    if (!el || !pairs.length) return;
    el.hidden = false;
    el.innerHTML = '';
    pairs.slice(0, 4).forEach(function (row) {
      var card = document.createElement('article');
      card.className = 'ilmas-pdp__fact';
      card.innerHTML = '<span class="ilmas-pdp__fact-lab"></span><strong class="ilmas-pdp__fact-val"></strong>';
      card.querySelector('.ilmas-pdp__fact-lab').textContent = row.label;
      card.querySelector('.ilmas-pdp__fact-val').textContent = row.value;
      el.appendChild(card);
    });
  }

  function collectParas(tmp) {
    var out = [];
    tmp.querySelectorAll('p').forEach(function (p) {
      if (out.length >= 4) return;
      if (p.closest('.expand-content, .attribute-values, .desc, .masque')) return;
      if (api.isMeaningfulP(p)) out.push(api.textOf(p));
    });
    tmp.querySelectorAll('p, h3').forEach(function (el) {
      if (el.closest('.expand-content, .attribute-values')) return;
      var t = api.textOf(el);
      if (!t || t.length < 50 || out.indexOf(t) !== -1) return;
      if (api.JUNK_RE.test(t) && t.length < 220) return;
      if (/^especificaciones|^dimensiones|^caracter|^beneficios/i.test(t)) return;
      if (out.length < 6) out.push(t);
    });
    return out;
  }

  var src = root.querySelector('[data-ilmas-src]');
  if (!src) return;
  var tmp = document.createElement('div');
  tmp.innerHTML = src.innerHTML;

  var paras = collectParas(tmp);
  var leadEl = root.querySelector('[data-ilmas-lead]');
  var descBody = root.querySelector('[data-ilmas-desc-body]');
  if (paras.length && leadEl) {
    var teaser = paras[0];
    if (teaser.length > 200) teaser = teaser.slice(0, 197).replace(/\s+\S*$/, '') + '…';
    leadEl.innerHTML = '';
    var leadP = document.createElement('p');
    leadP.textContent = teaser;
    leadEl.appendChild(leadP);
  }
  if (paras.length && descBody) fillItems(descBody, paras, 'p');

  var pairs = api.attrPairs(tmp);
  var specs = pairs.filter(function (p) { return !isFeature(p); }).slice(0, 8);
  var feats = featureNames(tmp, pairs);
  var specsWrap = root.querySelector('[data-ilmas-specs]');
  var specsDl = root.querySelector('[data-ilmas-specs-dl]');
  var featsWrap = root.querySelector('[data-ilmas-feats]');
  var featsList = root.querySelector('[data-ilmas-feats-list]');
  if (specs.length && specsWrap && specsDl) {
    specsWrap.hidden = false;
    fillItems(specsDl, specs.map(function (r) { return r.label + ': ' + r.value; }), 'article', 'ilmas-pdp__ficha-item');
  }
  if (feats.length && featsWrap && featsList) {
    featsWrap.hidden = false;
    fillItems(featsList, feats, 'li');
  }
  fillFacts(root.querySelector('[data-ilmas-facts]'), specs);
})();
